import Cookies from 'js-cookie';
import querystring from 'querystring';
import { apiExternal, domain } from '../../config';

const errors = {
  401: 'api_error_unauthorized',
  404: 'api_error_route_not_found',
  400: 'api_error_no_forms',
  405: 'api_error_no_forms',
  500: 'api_error_internal_error',
};
let maxAttempts = 5;

export class Api {
  static provider;

  static async ApiService(
    functionApi,
    getParams = null,
    query = null,
    data = null,
    optionHeader = null,
    contentType = 'json',
    signal = null,
  ) {
    let path = '';
    // const controller = new AbortController();
    const headers = {
      Authorization: `Bearer ${Api.provider.getToken()}`,
    };

    const { path: basePath, method, url, type } = apiExternal[functionApi];

    if (basePath === '/' && getParams) {
      path = getParams;
    } else if (basePath !== '/' && getParams) {
      let urlWithParam = basePath;
      Object.entries(getParams).forEach((param) => {
        if (param[1] === null) throw new Error(errors[400]);
        urlWithParam = urlWithParam.replace(`{${param[0]}}`, param[1]);
      });
      path = urlWithParam;
    } else path = basePath;

    let response = null;
    let queryParam = '';
    let req = '';
    // try {
    switch (method) {
      case 'DELETE':
      case 'GET':
        if (query) {
          queryParam = typeof query === 'object' ? `?${querystring.stringify(query)}` : `?${query}`;
        }
        response = await fetch(`${url}${path}${queryParam}`, {
          method,
          signal,
          headers: { ...headers, ...optionHeader },
        });
        break;
      case 'PUT':
      case 'POST':
        req = new Request(`${url}${path}`, {
          method,
          body: data,
          headers: {
            ...headers,
            ...optionHeader,
            ...(contentType === 'json' && { 'Content-Type': 'application/json' }),
          },
        });
        response = await fetch(req);
        break;
      default:
        break;
    }
    // } catch (e) {
    //   console.log('error', e);
    //   await Api.provider.refreshToken();
    // }
    if (maxAttempts > 0) maxAttempts -= 1;
    if (response.status === 401 && maxAttempts > 0) {
      try {
        await Api.provider.refreshToken();
        // recursive call
        const result = await Api.ApiService(functionApi, getParams, query, data, optionHeader, contentType);
        return result;
      } catch (e) {
        if (e.message === 'MISSING_REFRESH_TOKEN') {
          Object.entries(Cookies.get()).forEach(([key]) => {
            if (key !== 'appLanguage')
              document.cookie = `${key}=; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
          });
          window.location.replace('/login');
        }
      }
    }

    if (response.status === 406) {
      return {
        data: await response.json(),
        status: response.status,
      };
    }

    if ([423, 405].includes(response.status)) {
      throw new Error('api_error_inspection');
    }

    if (response.status > 299 || JSON.stringify(response.data) === '') {
      throw new Error('api_error_internal_error');
    }
    maxAttempts = 5;
    return {
      data: type === 'blob' ? await response.blob() : await response.json(),
      status: response.status,
      headers: { 'content-range': response.headers.get('content-range') },
    };
  }
}
